import type { TeachingUnitLessonUser } from '@didaskill/domain/courses/types';
import type { ITeachingUnitLessonUser } from '@didaskill/domain/courses/types/node';
import type { StudentCourseOptionalLesson } from '@didaskill/domain/users/types';
import type { IUserOptionalLesson } from '@didaskill/domain/users/types/node';

/**
 * Check if a student has activated the lesson as optional.
 *
 * @param optionalLessons - Student's course optional lessons.
 * @param lessonId - Lesson id to check.
 * @returns Student has lesson has option.
 */
export const hasStudentActivatedOptionalLesson = (
  optionalLessons: (StudentCourseOptionalLesson | IUserOptionalLesson)[],
  lessonId: string,
) => !!optionalLessons.find(({ lesson, enabled }) => lesson.toString() === lessonId && enabled);

/**
 * Check if a user is internal from Enaco.
 *
 * @param user - User.
 * @returns True if user is internal.
 */
export const isUserInternal = (user: TeachingUnitLessonUser | ITeachingUnitLessonUser) =>
  'role' in user && 'user' in user;
